import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SimpleForm, useNotify } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';

import { ReferralsForm } from './components/ReferralsFrom';

export const ReferralsCreate: React.FC = () => {
  const translate = useTypedTranslate();

  const notify = useNotify();

  function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <CreatePage
      listName={translate('app.referrals.title')}
      mutationOptions={{ onError }}
      title={translate('app.referrals.createTitle')}
    >
      <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
        <ReferralsForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" variant="outlined" />,
            <SaveButtonValidated key="save-button" label={translate('app.buttons.create')} />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </CreatePage>
  );
};
